import { ApiError } from './api-client'

/** The server's own message when there is one, otherwise a caller-supplied fallback. */
export function errorMessage(error: unknown, fallback: string): string {
  return error instanceof ApiError ? error.message : fallback
}
